import React from "react";

function Trending() {
  return <div>Trending</div>;
}

export default Trending;
